import {MessageNotificationTypeEnum} from '@/services/api-clients';

export function messageNotificationTypeIconFilter(type: MessageNotificationTypeEnum): string {
  switch(type) {
    case MessageNotificationTypeEnum.VehicleRentMissingDigitalDocuments: return 'mdi-car-clock';
    case MessageNotificationTypeEnum.VehicleReservationCreated: return 'mdi-car-clock';
    case MessageNotificationTypeEnum.VehicleReservationCancelledByDriver: return 'mdi-car-off';
    case MessageNotificationTypeEnum.SupportTicketCreated: return 'mdi-lifebuoy';
    case MessageNotificationTypeEnum.SupportTicketDriverMessage: return 'mdi-message-text';
    case MessageNotificationTypeEnum.SupportTicketClosedByDriver: return 'mdi-message-check';
    default: return '';
  }
}
